<div class="d-flex">
    <div class="btn-group mx-2">
        <button
            type="button"
            class="btn btn-default"
            tooltip="Undo the last drawing"
            placement="bottom"
            [disabled]="!hasDrawings"
            (click)="onUndo()">
            <i class="fa fa-undo text-large"></i>
        </button>

        <button
            type="button"
            class="btn btn-danger"
            tooltip="Remove all"
            tooltip-append-to-body="true"
            [disabled]="!hasDrawings"
            (click)="onRemoveAll()">
            <i class="fa fa-trash text-large"></i>
        </button>
    </div>

    <button type="button" class="btn btn-default" (click)="onDismiss()">Close</button>
</div>
